import { createAsyncAction } from 'redux-promise-middleware-actions';
import fileDownload from 'js-file-download';
import api from '../Api/apiIS';

import { getActionTypesResult } from '../utils';

const downloadFileConstants = {
    FILE_LOAD: 'FILE_LOAD'
};

export const downloadFileFulfilledConstants = getActionTypesResult(downloadFileConstants, '_FULFILLED');

const mapResToFile = (res, mime) => ({
    fileName: res.headers.filename,
    data: res.data,
    mime
});

const pdfMimeType = 'application/pdf';
const excelMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const excelOptions = {
    responseType: 'arraybuffer',
    headers: {
        'Content-Type': 'application/json',
        Accept: excelMimeType
    }
};
const pdfOptions = {
    responseType: 'arraybuffer',
    headers: {
        'Content-Type': 'application/json',
        Accept: pdfMimeType
    }
};

export const downloadPDF = createAsyncAction(downloadFileConstants.FILE_LOAD, async link => {
    const res = await api.get(link, pdfOptions);

    const fileMeta = mapResToFile(res, pdfMimeType);
    fileDownload(fileMeta.data, fileMeta.fileName, fileMeta.mime);

    return fileMeta;
});

export const downloadExcel = createAsyncAction(downloadFileConstants.FILE_LOAD, async link => {
    const res = await api.get(link, excelOptions);

    const fileMeta = mapResToFile(res, excelMimeType);
    fileDownload(fileMeta.data, fileMeta.fileName, fileMeta.mime);

    return fileMeta;
});
